import { render, staticRenderFns } from "./SongsRu.vue?vue&type=template&id=55ece736&"
import script from "./SongsRu.vue?vue&type=script&lang=js&"
export * from "./SongsRu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports